import { render, staticRenderFns } from "./safe-rescured.vue?vue&type=template&id=d5889b22&scoped=true&"
import script from "./safe-rescured.vue?vue&type=script&lang=js&"
export * from "./safe-rescured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5889b22",
  null
  
)

export default component.exports